import Ellipsis from "./Ellipsis";
import { searchGoogleTranslate } from "../utils";
import { useGetDefInContext, SourceLocation, WordView } from "../api-generated";
import { useCurrentDevice } from "../hooks";
import { useEffect } from "react";

interface Props {
  //NB: only for words for now
  word: WordView;
  onClick?: () => void;
  location: SourceLocation;
}

const SHARED_CLASSES = "text-xs text-fuchsia-700 block h-1";
const SHARED_STYLES: React.CSSProperties = {
  // lineHeight making the element shorter
  lineHeight: 0.5,
};

//SNIPPET: children prop
const WithStyles: React.FC<{
  children: React.ReactNode | React.ReactNode[];
}> = ({ children }) => {
  return (
    <span style={SHARED_STYLES} className={SHARED_CLASSES}>
      {children}
    </span>
  );
};

const InlineDef: React.FC<Props> = ({ word, onClick, location }) => {
  const { mutate, isLoading, isError, data } = useGetDefInContext();
  useEffect(() => mutate({ data: { location } }), [JSON.stringify(location)]);

  const { isComp } = useCurrentDevice();

  if (isLoading) {
    return (
      <WithStyles>
        <Ellipsis />
      </WithStyles>
    );
  }

  if (isError) {
    //TODO: error log here
    return <WithStyles>Error loading!</WithStyles>;
  }

  if (data === undefined) {
    return (
      <WithStyles>
        <></>
      </WithStyles>
    );
  }

  return (
    <WithStyles>
      <span
        //TODO: if this component stays, make it an actual button
        className={`inline-def text-center cursor-pointer hover:underline`}
        onClick={() => {
          if (onClick) {
            onClick();
          }
          if (isComp) {
            searchGoogleTranslate(word);
          }
        }}
      >
        {data.join(", ")}
      </span>
    </WithStyles>
  );
};

export default InlineDef;
